import BoletimSection from "../BoletimSection/BoletimSection";
import CardDotGrid from "../CardDotGrid/CardDotGrid";

function Estagio({ internship }) {
	const defaultInternship = {
		final_grade: "-",
		max_grade: "-",
		grades: [
			{
				title: "Documentação",
				grade: 0,
				max_grade: 5,
			},
			{
				title: "Relatório",
				grade: 0,
				max_grade: 5,
			},
		],
	};
	return (
		<BoletimSection
			title="Estágio"
			icon="suitcase"
		>
			<CardDotGrid
				approved={internship ? internship.approved : "default"}
				finalGrade={internship ? internship.final_grade : defaultInternship.final_grade}
				maxGrade={internship ? internship.max_grade : defaultInternship.max_grade}
				grades={internship ? internship.grades : defaultInternship.grades}
                approvedText={internship ? "Aprovado" : ""}
			/>
		</BoletimSection>
	);
}

export default Estagio;
